import React from "react";

const CampaignForm = ({
    formData,
    handleChange,
    handleSubmit,
    loading,
    isEdit = false,
}) => {

    return (

        <form
            className="campaign-form"
            onSubmit={handleSubmit}
        >

            <div className="form-group">
                <label>Campaign Title</label>

                <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                />
            </div>

            <div className="form-group">
                <label>Description</label>

                <textarea
                    name="description"
                    rows="5"
                    value={formData.description}
                    onChange={handleChange}
                    required
                />
            </div>

            <div className="form-row">

                <div className="form-group">
                    <label>Campaign Type</label>

                    <select
                        name="campaignType"
                        value={formData.campaignType}
                        onChange={handleChange}
                    >
                        <option value="Festival">Festival</option>
                        <option value="Referral">Referral</option>
                        <option value="Coupon">Coupon</option>
                        <option value="Cashback">Cashback</option>
                        <option value="Banner">Banner</option>
                        <option value="Email">Email</option>
                        <option value="SMS">SMS</option>
                        <option value="Push">Push</option>
                        <option value="Featured Provider">Featured Provider</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Audience</label>

                    <select
                        name="targetAudience"
                        value={formData.targetAudience}
                        onChange={handleChange}
                    >
                        <option value="All Customers">All Customers</option>
                        <option value="New Customers">New Customers</option>
                        <option value="Returning Customers">Returning Customers</option>
                        <option value="Premium Customers">Premium Customers</option>
                    </select>
                </div>

            </div>

            <div className="form-row">

                <div className="form-group">
                    <label>Button Text</label>

                    <input
                        type="text"
                        name="buttonText"
                        value={formData.buttonText}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Background Color</label>

                    <input
                        type="color"
                        name="backgroundColor"
                        value={formData.backgroundColor}
                        onChange={handleChange}
                    />
                </div>

            </div>

            <div className="form-row">

                <div className="form-group">
                    <label>Redirect Type</label>

                    <select
                        name="redirectType"
                        value={formData.redirectType}
                        onChange={handleChange}
                    >
                        <option value="Home">Home</option>
                        <option value="Food">Food</option>
                        <option value="Category">Category</option>
                        <option value="Provider">Provider</option>
                        <option value="Offer">Offer</option>
                        <option value="Coupon">Coupon</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Redirect Value</label>

                    <input
                        type="text"
                        name="redirectValue"
                        value={formData.redirectValue}
                        onChange={handleChange}
                    />
                </div>

            </div>

            <div className="form-row">

                <div className="form-group">
                    <label>Display Order</label>

                    <input
                        type="number"
                        name="displayOrder"
                        value={formData.displayOrder}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Status</label>

                    <select
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                    >
                        <option value="Running">Running</option>
                        <option value="Draft">Draft</option>
                        <option value="Scheduled">Scheduled</option>
                        <option value="Paused">Paused</option>
                        <option value="Completed">Completed</option>
                        <option value="Cancelled">Cancelled</option>
                    </select>
                </div>

            </div>

            <div className="form-row">

                <div className="form-group">
                    <label>Start Date</label>

                    <input
                        type="date"
                        name="startDate"
                        value={formData.startDate}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>End Date</label>

                    <input
                        type="date"
                        name="endDate"
                        value={formData.endDate}
                        onChange={handleChange}
                    />
                </div>

            </div>

            <div className="form-group">
                <label>Banner Image</label>

                <input
                    type="file"
                    name="banner"
                    accept="image/*"
                    onChange={handleChange}
                />
            </div>

            <button
                className="save-btn"
                type="submit"
                disabled={loading}
            >
                {loading
                    ? "Saving..."
                    : isEdit
                        ? "Update Campaign"
                        : "Create Campaign"}
            </button>

        </form>

    );

};

export default CampaignForm;